import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';

/**
 * /sso-callback is the landing route Clerk sends the browser back to after a redirect-based OAuth flow (Google/Apple).

  - When the user clicks “Continue with Google/Apple”, Clerk redirects them to the provider, then the provider redirects back to your app with auth result parameters.
  - <AuthenticateWithRedirectCallback /> on client/src/components/auth/SsoCallbackPage.tsx:1 reads those parameters, finalizes the Clerk sign-in/sign-up, creates the session, and then
    navigates to your post-auth destination (in your case /app via fallback redirects).

  Without a callback route, the redirect flow can’t complete in your SPA because there’s nowhere to “finish” the OAuth handshake client-side.
 */
const SsoCallbackPage = () => {
  return <AuthenticateWithRedirectCallback />;
};

export default SsoCallbackPage;
